import React from 'react';

const Menu = () => {
  return (
   <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.79956 13.3173H16.1412M7.79956 18.2H13.0191M10.1829 5.74927H14.9496C17.3329 5.74927 17.3329 4.52861 17.3329 3.30795C17.3329 0.866638 16.1412 0.866638 14.9496 0.866638H10.1829C8.99123 0.866638 7.79956 0.866638 7.79956 3.30795C7.79956 5.74927 8.99123 5.74927 10.1829 5.74927Z" stroke="#595A5B" stroke-width="1.69" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17.3811 3.46667C21.3894 3.68358 23.3996 5.16578 23.3996 10.6728V17.9031C23.3996 22.7233 22.1959 25.1333 16.1774 25.1333H8.95513C2.93661 25.1333 1.73291 22.7233 1.73291 17.9031V10.6728C1.73291 5.17784 3.7431 3.68358 7.75143 3.46667" stroke="#595A5B" stroke-width="1.69" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  );
};

export default Menu;

